module.exports = new __parcel__URL__("bossfight_you_are_ready_button.f83fd8fa.png").toString();